import { isoZ, z } from 'my-zod'

const integrationNameOptions = ['viator', 'zapier'] as const

const outfitterIntegrationApiKeyModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  integration: z.enum(integrationNameOptions),
  keyLength: z.number().int(),
  keyLast4: z.string().length(4, 'Must be 4 characters'),
  keyHash: z.string(),
  createdDate: isoZ.instant(),
  revocationDate: isoZ.instant().nullable()
})

export const OutfitterApiIntegrationSchemas = {
  outfitterIntegrationApiKeyModel,
  integrationNameOptions
}

export declare namespace OutfitterApiIntegrationSchemas {
  export type outfitterIntegrationApiKeyModel = z.infer<typeof outfitterIntegrationApiKeyModel>
  export type IntegrationName = (typeof integrationNameOptions)[number]
}
